var domainUrl = document.getElementById("site-url").innerText;

window.onload = function() {
    domainUrl = document.getElementById("site-url").innerText;
    if (window.jQuery) {
        // console.log("jquery present");
    } else {
        var jquery_script = document.createElement("script"); 
        jquery_script.src = "https://cdnjs.cloudflare.com/ajax/libs/jquery/3.5.1/jquery.min.js";  
        document.getElementsByTagName('head')[0].appendChild(jquery_script);        
    }
    var shopify_script = document.createElement("script"); 
    shopify_script.src = "https://cdn.shopify.com/s/shopify/api.jquery.js";
    document.getElementsByTagName('head')[0].appendChild(shopify_script);
}

// Setting count for add all to cart products
var addToCartCount;

// ADD ALL TO CART LINK
var addWorkToCartLink;
var addBasicToCartLink;
var addAllToCartLink;
var addEssentialToCartLink;

var url_string = window.location.href;
var url = new URL(url_string);
var products;
let selected_pdt;
var imgid = url.searchParams.get("id");
var resp_id = url.searchParams.get("resp_id");

var language_isocode = document.getElementById("site-iso-code").innerText;
var default_addToCartText = "Add to cart";
var default_addedToCartText = "Added to Cart!";
let outOfStock = "Out of Stock";
switch (language_isocode) {
    case "es":
        default_addToCartText = "Añadir a la cesta";
        default_addedToCartText = "¡Añadido al carrito!";
        outOfStock = "Agotado";
        break;
    case "it":
        default_addToCartText = "Aggiungi al carrello";
        default_addedToCartText = "Aggiunto al carrello!";
        outOfStock = "esaurito";
        break;
    case "fr":
        default_addToCartText = "Ajouter au panier";
        default_addedToCartText = "Ajouté au panier!";
        outOfStock = "rupture de stock";
        break;
    case "de":
        default_addToCartText = "In den Warenkorb legen";
        default_addedToCartText = "Zum Warenkorb hinzugefügt!";
        outOfStock = "ausverkauft";
        break;
    case "ja":
        default_addToCartText = "カートに追加";
        default_addedToCartText = "カートに追加されました!";
        outOfStock = "在庫切れ";
        break;
    case "ko":
        default_addToCartText = "카트에 추가하십시오";
        default_addedToCartText = "장바구니에 담았습니다!";
        outOfStock = "품절";
        break;
    case "pl":
        default_addToCartText = "Dodaj do koszyka";
        default_addedToCartText = "Dodano do koszyka!";
        outOfStock = "obecnie brak na stanie";
        break;
    case "pt":
        default_addToCartText = "Adicionar ao carrinho";
        default_addedToCartText = "Adicionado ao carrinho!";
        outOfStock = "fora de estoque";
        break;
    case "ru":
        default_addToCartText = "Добавить в корзину";
        default_addedToCartText = "Добавлено в корзину!";
        outOfStock = "распродано";
        break;
    case "da":
        default_addToCartText = "Tilføj til kurv";
        default_addedToCartText = "Tilføjet til indkøbskurv";
        outOfStock = "Udsolgt";
        break;
    default:
        default_addToCartText = "Add to cart";
        default_addedToCartText = "Added to Cart";
        outOfStock = "Out of Stock";
}

var essentialFoundList=[];

var tag_product_map = {
  tangent_selfie_acne:{
    essential:[8343239360794,4752330817617,4752325836881,4752327180369,8010231447834,8279534403866],
    basic:[8343239360794,4752330817617,4752325836881,4752327180369,8010231447834,8279534403866,8340517978394],
    work:[8343239360794,4752330817617,4752325836881,4752327180369,8010231447834,8279534403866,8340517978394,8589758923034,4752327016529,4752326361169],
    full:[8343239360794,4752330817617,4752325836881,4752327180369,8010231447834,8279534403866,8340517978394,8589758923034,4752327016529,4752326361169,4752326426705,8340647870746,8340740997402]
  },
  dryness:{
    essential:[6702510604369,4752325967953,4752326230097],
    basic:[6702510604369,4752325967953,4752326230097,6985836626001],
    work:[6702510604369,4752325967953,4752326230097,6985836626001,6842957725777,4752327016529],
    full:[6702510604369,4752325967953,4752326230097,6985836626001,6842957725777,4752327016529,4752325607505,8340439793946]
  },
  congested_pores:{
    essential:[6537971728465,8343239360794,4752330817617,4752325050449,4752325804113,6809827147857],
    basic:[6537971728465,8343239360794,4752330817617,4752325050449,4752325804113,6809827147857,6636806013009,6809846186065],
    work:[6537971728465,8343239360794,4752330817617,4752325050449,4752325804113,6809827147857,6636806013009,6809846186065,4752324919377],
    full:[6537971728465,8343239360794,4752330817617,4752325050449,4752325804113,6809827147857,6636806013009,6809846186065,4752324919377,6621889298513]
  },
  tangent_selfie_wrinkles:{
    essential:[4752326164561,8016345497882,4752330817617,4752326492241,4752329408593],
    basic:[4752326164561,8016345497882,4752330817617,4752326492241,4752329408593,8340849656090,4752327016529],
    work:[4752326164561,8016345497882,4752330817617,4752326492241,4752329408593,,8340849656090,4752327016529],
    full:[4752326164561,8016345497882,4752330817617,4752326492241,4752329408593,,8340849656090,4752327016529,6621889298513]
  },
  tangent_selfie_rosacea:{
    essential:[4752325967953,4752330817617,4752327606353,4752325541969],
    basic:[4752325967953,4752330817617,4752327606353,4752325541969,4752326099025],
    work:[4752325967953,4752330817617,4752327606353,4752325541969,4752326099025,8589756858650,8340439793946],
    full:[4752325967953,4752330817617,4752327606353,4752325541969,4752326099025,8589756858650,8340439793946,6621889298513]
  },
  dullness:{
    essential:[8010231447834,4752330817617,6702517878865,8016345497882],
    basic:[8010231447834,4752330817617,6702517878865,8016345497882,6809846186065,6642523275345],
    work:[8010231447834,4752330817617,6702517878865,8016345497882,6809846186065,6642523275345,6927513747537,6737055219793,8340787233050],
    full:[8010231447834,4752330817617,6702517878865,8016345497882,6809846186065,6642523275345,6927513747537,6737055219793,8340787233050,4752325607505,8340439793946,6621889298513]
  },
  maintain:{
    essential:[4752329408593,6702510604369,4752325836881,4752330817617,4752331112529],
    basic:[4752329408593,6702510604369,4752325836881,4752330817617,4752331112529,8340317667610],
    work:[4752329408593,6702510604369,4752325836881,4752330817617,4752331112529,8340317667610,6842957725777],
    full:[4752329408593,6702510604369,4752325836881,4752330817617,4752331112529,8340317667610,6842957725777,4752325607505,8340517978394,6621889298513]
  },
  tangent_selfie_spots:{
    essential:[8340517978394,8279534403866,6842957725777,4752325476433,4752330817617],
    basic:[8340517978394,8279534403866,6842957725777,4752325476433,4752330817617],
    work:[8340517978394,8279534403866,6842957725777,4752325476433,4752330817617],
    full:[8340517978394,8279534403866,6842957725777,4752325476433,4752330817617]
  },
  tangent_selfie_dark_circles:{
    essential:[4752325902417,4752325509201],
    basic:[4752325902417,4752325509201],
    work:[4752325902417,4752325509201],
    full:[4752325902417,4752325509201]
  }
}

var domainCurrency;

// Default url path for product
var variant_product_url;

var product_options_map = {};

var option1array = [];
var option2array = [];
var option3array = [];

var option1_ele_arr = [];
var option2_ele_arr = [];
var option3_ele_arr = [];

var variants_div;
var variantOption1_div;
var variantOption2_div;
var variantOption3_div;

// Options name mapped to variant id
var option2_variant_map = {};

const el = (sel, par) => (par||document).querySelector(sel);        
const elPopup = el("#tangent-popup-msg");      
const elPopupCondtion = el("#tangent-popup-msg-condition");

var upsell_products;

var essentialCart;
var allToCart;

var essential_product_element;
var all_product_element;

var active_essential_count = 0;
var active_basic_count = 0;
var active_work_count = 0;

var essential_product_array=[];
var basic_product_array=[];
var work_product_array=[];
var all_product_array=[];

var all_tags;

if (resp_id != null) {

    // Enable loader when response id is present
    // toggle_loader_view(true);
  
    // changeLoadingText("Fetching your results...");
    var checkout_url = "https://service.tangent.ai/shopify/get-checkout-products?resp_id=" + resp_id + "&self_serve=true" + "&multiple_variants=true";
    var xmlhttp = new XMLHttpRequest();

    xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState == XMLHttpRequest.DONE) { // XMLHttpRequest.DONE == 4
            if (xmlhttp.status == 200) {
                // Enable loader when response id is present
                // toggle_loader_view(false);
                var jsonData = JSON.parse(xmlhttp.responseText);
                products = jsonData.products;
                domainCurrency = document.getElementById("site-currency").innerText; 
                  
                all_tags = jsonData.tags;
                if (all_tags.includes('dedicate_2min')) {
                  document.getElementById("essential").classList.add("active");
                  document.getElementById("essential-products").style.display="flex";
                }
                else if (all_tags.includes('dedicate_5min')) {
                  document.getElementById("basics").classList.add("active");
                  document.getElementById("basic-products").style.display="flex";
                }
                else if (all_tags.includes('dedicate_10min')) {
                  document.getElementById("work").classList.add("active");
                  document.getElementById("work-products").style.display="flex";
                }
                else{
                  document.getElementById("all").classList.add("active");
                  document.getElementById("all-products").style.display="flex";
                }
                document.getElementById("tab-wrapper").style.display="block";
                
                allToCart = domainUrl + "/cart/add?id[]=";
                essentialCart = domainUrl + "/cart/add?id[]=";
                basicCart = domainUrl + "/cart/add?id[]=";
                workCart = domainUrl + "/cart/add?id[]=";
                
                // Default image hiding
                document.getElementById('tangent_selfie_div').style.display = "flex";
                document.getElementById('selfie_img').src = jsonData.selfie_url;
                if(jsonData.selfie_html!=null && jsonData.selfie_html!=undefined){
                  // document.getElementById("default-image").style.display="none";
                  // document.getElementById('selfie_img').src = jsonData.selfie_url;
                  // document.getElementById('tangent-selfie-container-div').innerHTML = jsonData.selfie_html;
                }
                else{
                  document.getElementById("tangent-img-container").style.display="none";
                  document.getElementById("selfie_img").style.display="none";
                }

                if (products.length > 0) {

                    document.getElementById('tangent-add-all-to-cart-essential').style.display = "block";
                    document.getElementById('tangent-add-all-to-cart-basic').style.display = "block";
                    document.getElementById('tangent-add-all-to-cart-work').style.display = "block";
                    document.getElementById('tangent-add-all-to-cart-all').style.display = "block";
                  
                    essential_product_element = document.getElementById('essential-products-grid');
                    basic_product_element = document.getElementById('basic-products-grid');
                    work_product_element = document.getElementById('work-products-grid');
                    all_product_element = document.getElementById('all-products-grid');

                    selected_pdt = {};
                    var active_product_count = 0;
                    var select_variant_obj;
                    for (var p = 0; p < products.length; p++) {
                        select_variant_obj = products[p].variants[0];
                      
                        option1array = [];
                        option2array = [];
                        option3array = [];
                        variants_div = null;
                        variant_product_url = domainUrl + '/products/';
                        var variant_price;

                        var imgsrc = "";
                        if (domainCurrency == "") {
                            domainCurrency = '$';
                        }
                        if (products[p].images != undefined) {
                            imgsrc = getVariantImage(products[p].variants[0].image_id,products[p]);
                        }
                        else{
                            imgsrc = "https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp";
                        }

                        variantOption1_div = document.createElement("div");
                        variantOption1_div.classList.add("tangent_option_div");

                        variantOption2_div = document.createElement("div");
                        variantOption2_div.classList.add("tangent_option_div");

                        variantOption3_div = document.createElement("div");
                        variantOption3_div.classList.add("tangent_option_div");

                        var variant_checkbox_elm = document.getElementById('tangent_variant_view_check');

                        variant_price = products[p].variants[0].price;
                        variant_product_url = variant_product_url + products[p].handle + "?variant=" + products[p].variants[0].id;
                        let selectedVariant = isSelectedVariantPresent(jsonData.selected_variants, products[p].id)
                        
                        // CHECK FOR VARIANT ENABLED
                        if (!selectedVariant.length && products[p].variants.length > 1) {
                            if (variant_checkbox_elm != undefined && variant_checkbox_elm != null) {
                                if (variant_checkbox_elm.value==true || variant_checkbox_elm.value=="true") {

                                    variants_div = document.createElement("div");
                                    variants_div.id = 'tangent_checkout_variants_div_' + p;
                                    variants_div.classList.add("tangent_checkout_variants_div");
                                    variants_div.style.display = "none";

                                    var variantsub_div = document.createElement("div");
                                    variants_div.appendChild(variantsub_div);
                                    var _variants = products[p].variants;
                                    option1_ele_arr = [];
                                    option2_ele_arr = [];
                                    option3_ele_arr = [];

                                    var option_obj = {};

                                    variants_div.style.display = "block";

                                    // Product Option 1 Name Element
                                    var option1_name = document.createElement("p");
                                    option1_name.id = "optionName_variant:product_" + p;
                                    option1_name.innerText = products[p].options[0].name + ":";
                                    option1_name.classList.add("tangent_option_name");
                                    variantOption1_div.append(option1_name);

                                    // Creating values for product option 1 
                                    var option1_values = products[p].options[0].values;
                                    for (var opt1v = 0; opt1v < option1_values.length; opt1v++) {
                                        var variants_option1 = document.createElement("p");
                                        variants_option1.id = "product_" + products[p].id + ":option_" + opt1v;
                                        variants_option1.title = option1_values[opt1v];
                                        variants_option1.innerText = option1_values[opt1v];
                                        variants_option1.classList.add("tangent_option");
                                        // variants_option1.classList.add("product_" + products[p].id + "v1");
                                        variants_option1.classList.add("tangent_options_1");

                                        if (!option1array.includes(option1_values[opt1v])) {
                                            option1array.push(option1_values[opt1v]);
                                            option1_ele_arr.push(variants_option1);
                                            variantOption1_div.appendChild(variants_option1);
                                        }
                                    }
                                    if (option1_ele_arr.length > 0) { option_obj["option1"] = option1_ele_arr; }

                                    // Product Option 2 Name Element
                                    if (products[p].options.length > 1) {
                                        var option2_name = document.createElement("p");
                                        option2_name.id = "optionName_variant:product_" + p;
                                        option2_name.innerText = products[p].options[1].name + ":";
                                        option2_name.classList.add("tangent_option_name");
                                        variantOption2_div.append(option2_name);
                                    }

                                    // Creating values for product option 2
                                    if (products[p].options[1] != undefined) {
                                        var option2_values = products[p].options[1].values;
                                        for (var opt2v = 0; opt2v < option2_values.length; opt2v++) {
                                            var variants_option2 = document.createElement("p");
                                            variants_option2.id = "product_" + products[p].id + ":option_" + opt2v;
                                            variants_option2.title = option2_values[opt2v];
                                            variants_option2.innerText = option2_values[opt2v];
                                            variants_option2.classList.add("tangent_option");
                                            // variants_option2.classList.add("product_" + products[p].id + "v2");
                                            variants_option2.classList.add("tangent_options_2");

                                            if (!option2array.includes(option2_values[opt2v])) {
                                                option2array.push(option2_values[opt2v]);
                                                option2_ele_arr.push(variants_option2);
                                                variantOption2_div.appendChild(variants_option2);
                                            }
                                        }
                                    }
                                    if (option2_ele_arr.length) { option_obj["option2"] = option2_ele_arr; }

                                    // Product Option 3 Name Element
                                    if (products[p].options.length > 2) {
                                        var option3_name = document.createElement("p");
                                        option3_name.id = "optionName_variant:product_" + p;
                                        option3_name.innerText = products[p].options[2].name + ":";
                                        option3_name.classList.add("tangent_option_name");
                                        variantOption3_div.append(option3_name);
                                    }

                                    // Creating values for product option 3
                                    if (products[p].options[2] != undefined) {
                                        var option3_values = products[p].options[2].values;
                                        for (var opt3v = 0; opt3v < option3_values.length; opt3v++) {
                                            var variants_option3 = document.createElement("p");
                                            variants_option3.id = "product_" + products[p].id + ":option_" + opt3v;
                                            variants_option3.title = option3_values[opt3v];
                                            variants_option3.innerText = option3_values[opt3v];
                                            variants_option3.classList.add("tangent_option");
                                            // variants_option3.classList.add("product_" + products[p].id + "v3");
                                            variants_option3.classList.add("tangent_options_3");

                                            if (!option3array.includes(option3_values[opt3v])) {
                                                option3array.push(option3_values[opt3v]);
                                                option3_ele_arr.push(variants_option3);
                                                variantOption3_div.appendChild(variants_option3);
                                            }
                                        }
                                    }
                                    if (option3_ele_arr.length > 0) { option_obj["option3"] = option3_ele_arr; }

                                    product_options_map[products[p].id] = option_obj;

                                    var option2_var = {};
                                    var selected_variant;

                                    // All options for the product
                                    var options1;
                                    var options2;
                                    var options3;

                                    for (var v = 0; v < _variants.length; v++) {
                                        var optVariant;
                                        if (_variants[v].option1 != null) {
                                            optVariant = _variants[v].option1
                                        }
                                        if (_variants[v].option2 != null) {
                                            optVariant = optVariant + "_" + _variants[v].option2
                                        }
                                        if (_variants[v].option3 != null) {
                                            optVariant = optVariant + "_" + _variants[v].option3
                                        }

                                        option2_var[optVariant] = _variants[v];
                                        option2_variant_map[products[p].id] = option2_var;
                                    }

                                    // When product has no variant previously selected
                                    // Default Select Option 1
                                    if (product_options_map[products[p].id].option1 != undefined) {
                                        if (product_options_map[products[p].id].option1.length > 0) {
                                            options1 = product_options_map[products[p].id].option1;
                                            options1[0].classList.add("tangent_selected-variant");
                                        }
                                    }

                                    // Default Select Option 2
                                    if (product_options_map[products[p].id].option2 != undefined) {
                                        if (product_options_map[products[p].id].option2.length > 0) {
                                            options2 = product_options_map[products[p].id].option2;
                                            options2[0].classList.add("tangent_selected-variant");
                                        }
                                    }

                                    // Default Select Option 3
                                    if (product_options_map[products[p].id].option3 != undefined) {
                                        if (product_options_map[products[p].id].option3.length > 0) {
                                            options3 = product_options_map[products[p].id].option3;
                                            options3[0].classList.add("tangent_selected-variant");
                                        }
                                    }

                                    selected_pdt[products[p].id] = _variants[0].id + "";
                                    select_variant_obj = _variants[0];

                                    variant_price = _variants[0].price;
                                    variant_product_url = variant_product_url + products[p].handle + "?variant=" + _variants[0].id;

                                    variantsub_div.appendChild(variantOption1_div);
                                    variantsub_div.appendChild(variantOption2_div);
                                    variantsub_div.appendChild(variantOption3_div);

                                }
                            }
                        }
                        if (selected_pdt[products[p].id] == null) {
                            selected_pdt[products[p].id] = products[p].variants[0].id;
                        }
                      
                        if (!selectedVariant.length && (products[p].variants.length > 1 || products[p].variants.length == 1)) {
                            var product_html;
                            if(domainUrl==undefined){
                                domainUrl = document.getElementById("site-url").innerText;
                            }
                          
                            essen_product_html = '<div><a id="essen_url_tangent_product_' + p + '" class="tangent-text-link" target="_blank" href="' + variant_product_url + '"><img id="essen_image_tangent_product_' + products[p].id + '" src="' + imgsrc + '" class="tangent_product_image"><p class="tangent-product-title tangent_product_title_text"><b>' + products[p].title + '</b></p><p id="essen_price_tangent_product_' + products[p].id + '" class="tangent_product_price_text">' + domainCurrency + variant_price + '</p></a><div id="essen_tangent_product_' + products[p].id + '"></div><a class="tangent-product-add-btn-wrapper" id="essen_cart_tangent_product_' + products[p].id + '" onclick="addToCart('+products[p].id+',0)" href="javascript: void(0)"><p class="tangent-btn-add tangent_add_to_cart_button" id="essen_cart_tangent_product_' + products[p].id + '_text">' + default_addToCartText + '</p></a><div/>';
                            basic_product_html = '<div><a id="basic_url_tangent_product_' + p + '" class="tangent-text-link" target="_blank" href="' + variant_product_url + '"><img id="basic_image_tangent_product_' + products[p].id + '" src="' + imgsrc + '" class="tangent_product_image"><p class="tangent-product-title tangent_product_title_text"><b>' + products[p].title + '</b></p><p id="basic_price_tangent_product_' + products[p].id + '" class="tangent_product_price_text">' + domainCurrency + variant_price + '</p></a><div id="basic_tangent_product_' + products[p].id + '"></div><a class="tangent-product-add-btn-wrapper" id="basic_cart_tangent_product_' + products[p].id + '" onclick="addToCart('+products[p].id+',1)" href="javascript: void(0)"><p class="tangent-btn-add tangent_add_to_cart_button" id="basic_cart_tangent_product_' + products[p].id + '_text">' + default_addToCartText + '</p></a><div/>';
                            work_product_html = '<div><a id="work_url_tangent_product_' + p + '" class="tangent-text-link" target="_blank" href="' + variant_product_url + '"><img id="work_image_tangent_product_' + products[p].id + '" src="' + imgsrc + '" class="tangent_product_image"><p class="tangent-product-title tangent_product_title_text"><b>' + products[p].title + '</b></p><p id="work_price_tangent_product_' + products[p].id + '" class="tangent_product_price_text">' + domainCurrency + variant_price + '</p></a><div id="work_tangent_product_' + products[p].id + '"></div><a class="tangent-product-add-btn-wrapper" id="work_cart_tangent_product_' + products[p].id + '" onclick="addToCart('+products[p].id+',2)" href="javascript: void(0)"><p class="tangent-btn-add tangent_add_to_cart_button" id="work_cart_tangent_product_' + products[p].id + '_text">' + default_addToCartText + '</p></a><div/>';
                            all_product_html = '<div><a id="all_url_tangent_product_' + p + '" class="tangent-text-link" target="_blank" href="' + variant_product_url + '"><img id="all_image_tangent_product_' + products[p].id + '" src="' + imgsrc + '" class="tangent_product_image"><p class="tangent-product-title tangent_product_title_text"><b>' + products[p].title + '</b></p><p id="all_price_tangent_product_' + products[p].id + '" class="tangent_product_price_text">' + domainCurrency + variant_price + '</p></a><div id="all_tangent_product_' + products[p].id + '"></div><a class="tangent-product-add-btn-wrapper" id="all_cart_tangent_product_' + products[p].id + '" onclick="addToCart('+products[p].id+',3)" href="javascript: void(0)"><p class="tangent-btn-add tangent_add_to_cart_button" id="all_cart_tangent_product_' + products[p].id + '_text">' + default_addToCartText + '</p></a><div/>';

                            var addtocartlink = false;
                          
                            var ele_array_map={}
                            if(option1_ele_arr.length>0){
                              ele_array_map["option1"] = option1_ele_arr;
                            }
                            if(option2_ele_arr.length>0){
                              ele_array_map["option2"] = option2_ele_arr;
                            }
                            if(option3_ele_arr.length>0){
                              ele_array_map["option3"] = option3_ele_arr;
                            }
                            // Check and add to essential
                            var essentialToCartLinkStatus = addToEssential(products[p].id,essen_product_html,ele_array_map);
                            
                            var basicToCartLinkStatus = addToBasic(products[p].id,basic_product_html,ele_array_map);
                            
                            var workToCartLinkStatus = addToWork(products[p].id,work_product_html,ele_array_map);
                            
                            
                            // TO verify if added to all products section
                            var allToCartLinkStatus = addToAll(products[p].id,all_product_html,ele_array_map);
                            
                            var esse_ele = document.getElementById("essen_cart_tangent_product_" + products[p].id);
                            var essen_ele_text = document.getElementById("essen_cart_tangent_product_" + products[p].id + "_text");
                          
                            var basic_ele = document.getElementById("basic_cart_tangent_product_" + products[p].id);
                            var basic_ele_text = document.getElementById("basic_cart_tangent_product_" + products[p].id + "_text");
                          
                            var work_ele = document.getElementById("work_cart_tangent_product_" + products[p].id);
                            var work_ele_text = document.getElementById("work_cart_tangent_product_" + products[p].id + "_text");
                          
                            var all_ele = document.getElementById("all_cart_tangent_product_" + products[p].id);
                            var all_ele_text = document.getElementById("all_cart_tangent_product_" + products[p].id + "_text");
                          
                            var essen_variant_element = document.getElementById('essen_tangent_product_' + products[p].id);
                            var basic_variant_element = document.getElementById('basic_tangent_product_' + products[p].id);
                            var work_variant_element = document.getElementById('work_tangent_product_' + products[p].id);
                            var all_variant_element = document.getElementById('all_tangent_product_' + products[p].id);
                            if(variants_div!=undefined){
                                const essential_variants = variants_div.cloneNode(true);
                                const basic_variants = variants_div.cloneNode(true);
                                const work_variants = variants_div.cloneNode(true);
                                const all_variants = variants_div.cloneNode(true);
                                
                                if(essen_variant_element!=null){
                                  var options = essential_variants.getElementsByClassName("tangent_option");
                                  for(var op=0;op<options.length;op++){
                                    var optid = options[op].id;
                                    options[op].setAttribute('id', 'essen_'+optid);
                                    
                                    if(options[op].classList.contains("tangent_options_1")){
                                      options[op].classList.add("essen_product_" + products[p].id + "v1");
                                    }
                                    if(options[op].classList.contains("tangent_options_2")){
                                      options[op].classList.add("essen_product_" + products[p].id + "v2");
                                    }
                                    if(options[op].classList.contains("tangent_options_3")){
                                      options[op].classList.add("essen_product_" + products[p].id + "v3");
                                    }
                                  }
                                  essen_variant_element.appendChild(essential_variants);
                                }
                                if(basic_variant_element!=null){
                                  var options = basic_variants.getElementsByClassName("tangent_option");
                                  for(var op=0;op<options.length;op++){
                                    var optid = options[op].id;
                                    options[op].setAttribute('id', 'basic_'+optid);
                                    
                                    if(options[op].classList.contains("tangent_options_1")){
                                      options[op].classList.add("basic_product_" + products[p].id + "v1");
                                    }
                                    if(options[op].classList.contains("tangent_options_2")){
                                      options[op].classList.add("basic_product_" + products[p].id + "v2");
                                    }
                                    if(options[op].classList.contains("tangent_options_3")){
                                      options[op].classList.add("basic_product_" + products[p].id + "v3");
                                    }
                                  }
                                  basic_variant_element.appendChild(basic_variants);
                                }
                                if(work_variant_element!=null){
                                  var options = work_variants.getElementsByClassName("tangent_option");
                                  for(var op=0;op<options.length;op++){
                                    var optid = options[op].id;
                                    options[op].setAttribute('id', 'work_'+optid);
                                    
                                    if(options[op].classList.contains("tangent_options_1")){
                                      options[op].classList.add("work_product_" + products[p].id + "v1");
                                    }
                                    if(options[op].classList.contains("tangent_options_2")){
                                      options[op].classList.add("work_product_" + products[p].id + "v2");
                                    }
                                    if(options[op].classList.contains("tangent_options_3")){
                                      options[op].classList.add("work_product_" + products[p].id + "v3");
                                    }
                                  }
                                  work_variant_element.appendChild(work_variants);
                                }
                                if(all_variant_element!=null){
                                  var options = all_variants.getElementsByClassName("tangent_option");
                                  for(var op=0;op<options.length;op++){
                                    var optid = options[op].id;
                                    options[op].setAttribute('id', 'all_'+optid);
                                    
                                    if(options[op].classList.contains("tangent_options_1")){
                                      options[op].classList.add("all_product_" + products[p].id + "v1");
                                    }
                                    if(options[op].classList.contains("tangent_options_2")){
                                      options[op].classList.add("all_product_" + products[p].id + "v2");
                                    }
                                    if(options[op].classList.contains("tangent_options_3")){
                                      options[op].classList.add("all_product_" + products[p].id + "v3");
                                    }
                                  }
                                  all_variant_element.appendChild(all_variants);
                                }
                            }
                            // Check if Product is active
                            if (products[p].status == "active") {
                                if(esse_ele!=null){
                                  esse_ele.classList.remove("disable-btn-wrapper");
                                }
                                if(basic_ele!=null){
                                  basic_ele.classList.remove("disable-btn-wrapper");
                                }
                                if(work_ele!=null){
                                  work_ele.classList.remove("disable-btn-wrapper");
                                }
                                if(all_ele!=null){
                                  all_ele.classList.remove("disable-btn-wrapper");
                                }
                                
                                if(select_variant_obj.inventory_policy == "deny"){
                                    if(select_variant_obj.inventory_quantity<1){
                                      if(select_variant_obj.inventory_management!=null){
                                        if(esse_ele!=null){
                                          essen_ele_text.innerHTML = outOfStock;
                                          esse_ele.classList.add("disable-btn-wrapper");
                                        }
                                        
                                        if(basic_ele!=null){
                                          basic_ele_text.innerHTML = outOfStock;
                                          basic_ele.classList.add("disable-btn-wrapper");
                                        }
                                        
                                        if(work_ele!=null){
                                          work_ele_text.innerHTML = outOfStock;
                                          work_ele.classList.add("disable-btn-wrapper");
                                        }
                                        if(all_ele!=null){
                                          all_ele_text.innerHTML = outOfStock;
                                          all_ele.classList.add("disable-btn-wrapper");
                                        }
                                      }
                                      else{
                                        addtocartlink = true;
                                      }
                                    }
                                    else{
                                        addtocartlink = true;
                                    }
                                }
                                else{
                                    addtocartlink = true;
                                } 

                                if(allToCartLinkStatus && addtocartlink){
                                 if (active_product_count == 0) {
                                      allToCart = allToCart + products[p].variants[0].id;
                                  }
                                  else {
                                      allToCart = allToCart + '&id[]=' + products[p].variants[0].id;
                                  }
                                  active_product_count = active_product_count + 1;
                                }
                                if(basicToCartLinkStatus && addtocartlink){
                                 if (active_basic_count == 0) {
                                      basicCart = basicCart + products[p].variants[0].id;
                                  }
                                  else {
                                      basicCart = basicCart + '&id[]=' + products[p].variants[0].id;
                                  }
                                  active_basic_count = active_basic_count + 1;
                                }
                                if(workToCartLinkStatus && addtocartlink){
                                 if (active_work_count == 0) {
                                      workCart = workCart + products[p].variants[0].id;
                                  }
                                  else {
                                      workCart = workCart + '&id[]=' + products[p].variants[0].id;
                                  }
                                  active_work_count = active_work_count + 1;
                                }
                                if(essentialToCartLinkStatus && addtocartlink){
                                 if (active_essential_count == 0) {
                                      essentialCart = essentialCart + products[p].variants[0].id;
                                  }
                                  else {
                                      essentialCart = essentialCart + '&id[]=' + products[p].variants[0].id;
                                  }
                                  active_essential_count = active_essential_count + 1;
                                }
                            }
                            else {
                                if(esse_ele!=null){
                                  essen_ele_text.innerHTML = outOfStock;
                                  esse_ele.classList.add("disable-btn-wrapper");
                                }
                              
                                if(basic_ele!=null){
                                  basic_ele_text.innerHTML = outOfStock;
                                  basic_ele.classList.add("disable-btn-wrapper");
                                }
                                if(work_ele!=null){
                                  work_ele_text.innerHTML = outOfStock;
                                  work_ele.classList.add("disable-btn-wrapper");
                                }
                                if(all_ele!=null){
                                  all_ele_text.innerHTML = outOfStock;
                                  all_ele.classList.add("disable-btn-wrapper");
                                }
                              
                            }
                        }
                        //displaying selected products
                        if (selectedVariant.length) {
                            for (let i = 0; i < selectedVariant.length; i++) {
                                products[p].variants.forEach((variant) => {
                                    if (selectedVariant[i] == variant.id) {
                                        let imgurl = getVariantImage(variant.image_id,products[p]);
                                        let product_url = domainUrl + "/products/" + products[p].handle + "?variant=" + variant.id;
                                        
                                        let addTocartClass; 
                                        let buttonText;

                                        var addtocartlink = false;
                                        if(variant.inventory_policy == "deny"){
                                            if(variant.inventory_quantity<1){
                                              if(variant.inventory_management!=null){
                                                addTocartClass = "disable-btn-wrapper";
                                                buttonText = outOfStock;
                                              }  
                                              else{
                                                buttonText = default_addToCartText;
                                                addtocartlink = true;
                                              }
                                            }
                                            else{
                                                buttonText = default_addToCartText;
                                                addtocartlink = true;
                                            }
                                        }
                                        else{
                                            buttonText = default_addToCartText;
                                            addtocartlink = true;                                            
                                        }
                                        var product_html;
                                        selected_pdt[products[p].id] = variant.id;
                                        variant_price = variant.price;
                                      
                                        essen_product_html = '<div><a id="essen_url_tangent_product_' + p + '" class="tangent-text-link" target="_blank" href="' + product_url + '"><img id="essen_image_tangent_product_' + products[p].id + '" src="' + imgurl + '"  class="tangent_product_image"><p class="tangent-product-title tangent_product_title_text"><b>' + products[p].title + '</b></p><p class="tangent-variant-title tangent_variant_title_text"><b>' + variant.title + '</b></p><p id="essen_price_tangent_product_' + products[p].id + '" class="tangent_product_price_text">' + domainCurrency + variant_price + '</p></a><div id="essen_tangent_product_' + products[p].id + '"></div><a class="tangent-product-add-btn-wrapper' + addTocartClass + '" id="essen_cart_tangent_product_' + products[p].id + '" onclick="addToCart('+products[p].id+',0)" href="javascript: void(0)"><p class="tangent-btn-add tangent_add_to_cart_button" id="essen_cart_tangent_product_' + products[p].id + '_text">' + buttonText + '</p></a><div/>';
                                        basic_product_html = '<div><a id="basic_url_tangent_product_' + p + '" class="tangent-text-link" target="_blank" href="' + product_url + '"><img id="basic_image_tangent_product_' + products[p].id + '" src="' + imgurl + '"  class="tangent_product_image"><p class="tangent-product-title tangent_product_title_text"><b>' + products[p].title + '</b></p><p class="tangent-variant-title tangent_variant_title_text"><b>' + variant.title + '</b></p><p id="basic_price_tangent_product_' + products[p].id + '" class="tangent_product_price_text">' + domainCurrency + variant_price + '</p></a><div id="basic_tangent_product_' + products[p].id + '"></div><a class="tangent-product-add-btn-wrapper' + addTocartClass + '" id="basic_cart_tangent_product_' + products[p].id + '" onclick="addToCart('+products[p].id+',1)" href="javascript: void(0)"><p class="tangent-btn-add tangent_add_to_cart_button" id="basic_cart_tangent_product_' + products[p].id + '_text">' + buttonText + '</p></a><div/>';
                                        work_product_html = '<div><a id="work_url_tangent_product_' + p + '" class="tangent-text-link" target="_blank" href="' + product_url + '"><img id="work_image_tangent_product_' + products[p].id + '" src="' + imgurl + '"  class="tangent_product_image"><p class="tangent-product-title tangent_product_title_text"><b>' + products[p].title + '</b></p><p class="tangent-variant-title tangent_variant_title_text"><b>' + variant.title + '</b></p><p id="work_price_tangent_product_' + products[p].id + '" class="tangent_product_price_text">' + domainCurrency + variant_price + '</p></a><div id="work_tangent_product_' + products[p].id + '"></div><a class="tangent-product-add-btn-wrapper' + addTocartClass + '" id="work_cart_tangent_product_' + products[p].id + '" onclick="addToCart('+products[p].id+',2)" href="javascript: void(0)"><p class="tangent-btn-add tangent_add_to_cart_button" id="work_cart_tangent_product_' + products[p].id + '_text">' + buttonText + '</p></a><div/>';
                                        all_product_html = '<div><a id="all_url_tangent_product_' + p + '" class="tangent-text-link" target="_blank" href="' + product_url + '"><img id="all_image_tangent_product_' + products[p].id + '" src="' + imgurl + '"  class="tangent_product_image"><p class="tangent-product-title tangent_product_title_text"><b>' + products[p].title + '</b></p><p class="tangent-variant-title tangent_variant_title_text"><b>' + variant.title + '</b></p><p id="all_price_tangent_product_' + products[p].id + '" class="tangent_product_price_text allprice">' + domainCurrency + variant_price + '</p></a><div id="all_tangent_product_' + products[p].id + '"></div><a class="tangent-product-add-btn-wrapper' + addTocartClass + '" id="all_cart_tangent_product_' + products[p].id + '" onclick="addToCart('+products[p].id+',3)" href="javascript: void(0)"><p class="tangent-btn-add tangent_add_to_cart_button" id="all_cart_tangent_product_' + products[p].id + '_text">' + buttonText + '</p></a><div/>';
                                        var ele_array_map={}
                                        if(option1_ele_arr.length>0){
                                          ele_array_map["option1"] = option1_ele_arr;
                                        }
                                        if(option2_ele_arr.length>0){
                                          ele_array_map["option2"] = option2_ele_arr;
                                        }
                                        if(option3_ele_arr.length>0){
                                          ele_array_map["option3"] = option3_ele_arr;
                                        }
                                        // Check and all to Essential
                                        addToEssential(products[p].id,essen_product_html,ele_array_map);
                                        addToBasic(products[p].id,basic_product_html,ele_array_map);
                                        addToWork(products[p].id,work_product_html,ele_array_map);
                                        var aClink = addToAll(products[p].id,all_product_html,ele_array_map);
                                        if(aClink && addtocartlink){
                                          if (active_product_count == 0) {
                                              allToCart += variant.id;
                                          } else {
                                              allToCart += "&id[]=" + variant.id;
                                          }
                                          active_product_count++;
                                        }
                                      

                                        var essen_variant_element = document.getElementById('essen_tangent_product_' + products[p].id);
                                        var basic_variant_element = document.getElementById('basic_tangent_product_' + products[p].id);
                                        var work_variant_element = document.getElementById('work_tangent_product_' + products[p].id);
                                        var all_variant_element = document.getElementById('all_tangent_product_' + products[p].id);
                                      
                                        if(variants_div!=undefined){
                                            const essential_variants = variants_div.cloneNode(true);
                                            const basic_variants = variants_div.cloneNode(true);
                                            const work_variants = variants_div.cloneNode(true);
                                            const all_variants = variants_div.cloneNode(true);
                                            
                                            if(essen_variant_element!=null){
                                              var options = essential_variants.getElementsByClassName("tangent_option");
                                              for(var op=0;op<options.length;op++){
                                                var optid = options[op].id;
                                                options[op].setAttribute('id', 'essen_'+optid);
                                                
                                                if(options[op].classList.contains("tangent_options_1")){
                                                  options[op].classList.add("essen_product_" + products[p].id + "v1");
                                                }
                                                if(options[op].classList.contains("tangent_options_2")){
                                                  options[op].classList.add("essen_product_" + products[p].id + "v2");
                                                }
                                                if(options[op].classList.contains("tangent_options_3")){
                                                  options[op].classList.add("essen_product_" + products[p].id + "v3");
                                                }
                                              }
                                              essen_variant_element.appendChild(essential_variants);
                                            }
                                            if(basic_variant_element!=null){
                                              var options = basic_variants.getElementsByClassName("tangent_option");
                                              for(var op=0;op<options.length;op++){
                                                var optid = options[op].id;
                                                options[op].setAttribute('id', 'basic_'+optid);
                                                
                                                if(options[op].classList.contains("tangent_options_1")){
                                                  options[op].classList.add("basic_product_" + products[p].id + "v1");
                                                }
                                                if(options[op].classList.contains("tangent_options_2")){
                                                  options[op].classList.add("basic_product_" + products[p].id + "v2");
                                                }
                                                if(options[op].classList.contains("tangent_options_3")){
                                                  options[op].classList.add("basic_product_" + products[p].id + "v3");
                                                }
                                              }
                                              basic_variant_element.appendChild(basic_variants);
                                            }
                                            if(work_variant_element!=null){
                                              var options = work_variants.getElementsByClassName("tangent_option");
                                              for(var op=0;op<options.length;op++){
                                                var optid = options[op].id;
                                                options[op].setAttribute('id', 'work_'+optid);
                                                
                                                if(options[op].classList.contains("tangent_options_1")){
                                                  options[op].classList.add("work_product_" + products[p].id + "v1");
                                                }
                                                if(options[op].classList.contains("tangent_options_2")){
                                                  options[op].classList.add("work_product_" + products[p].id + "v2");
                                                }
                                                if(options[op].classList.contains("tangent_options_3")){
                                                  options[op].classList.add("work_product_" + products[p].id + "v3");
                                                }
                                              }
                                              work_variant_element.appendChild(work_variants);
                                            }
                                            if(all_variant_element!=null){
                                              var options = all_variants.getElementsByClassName("tangent_option");
                                              for(var op=0;op<options.length;op++){
                                                var optid = options[op].id;
                                                options[op].setAttribute('id', 'all_'+optid);
                                                
                                                if(options[op].classList.contains("tangent_options_1")){
                                                  options[op].classList.add("all_product_" + products[p].id + "v1");
                                                }
                                                if(options[op].classList.contains("tangent_options_2")){
                                                  options[op].classList.add("all_product_" + products[p].id + "v2");
                                                }
                                                if(options[op].classList.contains("tangent_options_3")){
                                                  options[op].classList.add("all_product_" + products[p].id + "v3");
                                                }
                                              }
                                              all_variant_element.appendChild(all_variants);
                                            }
                                        }
                                    }
                                })
                            }
                        }
                    }
                    addAllToCartLink = allToCart;
                    addEssentialToCartLink = essentialCart;
                    addBasicToCartLink = basicCart;
                    addWorkToCartLink = workCart;
                    addToCartCount = active_product_count;
                  
                    // ENABLE EVENT LISTENER FOR ALL OPTIONS
                    var all_options = document.getElementsByClassName('tangent_option');
                    for (var o = 0; o < all_options.length; o++) {
                        all_options[o].addEventListener(
                            'click',
                            function () { changePdtVariant(this); },
                            false
                        );
                    }
                }
                else {
                    document.getElementById('tangent-general-text').innerHTML = "No products found. Please retry!";
                    console.log("No products found Please retry");
                }

                if (jsonData.description != '') {
                    document.getElementById('tangent-checkout-description').style.display = "block";
                    document.getElementById('tangent-checkout-description').innerHTML = jsonData.description;
                }
                else {

                    document.getElementById('tangent-general-text').style.display = "block";
                    console.log("No descripton found");
                }
            }
            else if (xmlhttp.status == 400) {
                console.log('There was an error 400');
            }
            else {
                console.log('Something else other than 200 was returned');
            }
        }
    };

    xmlhttp.open("GET", checkout_url, true);
    xmlhttp.send();

}

function addToEssential(pid,html, ele_map){
  var added = false;
  for (const key in tag_product_map) {
    if (all_tags.includes(key)) {
      var essential_pdt_ids = tag_product_map[key].essential;
      if(essential_pdt_ids.includes(pid) && !essential_product_array.includes(pid)){
        essential_product_array.push(pid);
        added = true;
        essential_product_element.innerHTML = essential_product_element.innerHTML + html; 
      }
    }
  }
  return added;
}

function addToBasic(pid,html, ele_map){
  var added = false;
  for (const key in tag_product_map) {
    if (all_tags.includes(key)) {
      var basic_pdt_ids = tag_product_map[key].basic;
      if(basic_pdt_ids.includes(pid) && !basic_product_array.includes(pid)){
        basic_product_array.push(pid);
        added = true;
        basic_product_element.innerHTML = basic_product_element.innerHTML + html; 
      }
    }
  }
  return added;
}

function addToWork(pid,html, ele_map){
  var added = false;
  for (const key in tag_product_map) {
    if (all_tags.includes(key)) {
      var work_pdt_ids = tag_product_map[key].work;
      if(work_pdt_ids.includes(pid) && !work_product_array.includes(pid)){
        work_product_array.push(pid);
        added = true;
        work_product_element.innerHTML = work_product_element.innerHTML + html; 
      }
    }
  }
  return added;
}

function addToAll(pid,html, ele_map){
  var addTOAll = false;
  for (const key in tag_product_map) {
    if (all_tags.includes(key)) {
      var all_pdt_ids = tag_product_map[key].full;
      if(all_pdt_ids.includes(pid) && !all_product_array.includes(pid)){
        all_product_array.push(pid);
        addTOAll = true;
        all_product_element.innerHTML = all_product_element.innerHTML + html;
      } 
    }
  }
  return addTOAll;
}

function addAllTocartFunction(type) {                     
    if (addToCartCount > 0) {
        switch(type) {
          case 'all':
            document.getElementById('tangent-add-all-to-cart-all').setAttribute("href", addAllToCartLink);
            break;
          case 'basic':
            document.getElementById('tangent-add-all-to-cart-basic').setAttribute("href", addBasicToCartLink);
            break;
          case 'work':
            document.getElementById('tangent-add-all-to-cart-work').setAttribute("href", addWorkToCartLink);
            break;
          default:
            document.getElementById('tangent-add-all-to-cart-essential').setAttribute("href", addEssentialToCartLink);
        }
    }
    else {
        var x = document.getElementById("message-text");
        x.innerHTML = "We're currently sold out of the selected product(s). Please check back later!";
        x.className = "show";
        setTimeout(function () { x.className = x.className.replace("show", ""); }, 5000);
    }
}

function clickHandle(evt, eName) {
  let i, tabcontent, tablinks;

  // This is to clear the previous clicked content.
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  // Set the tab to be "active".
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }

  // Display the clicked tab and set it to active.
  document.getElementById(eName).style.display = "flex";
  
  evt.currentTarget.className += " active";
}

function changePdtVariant(ele) {
    var ele_Integer =0;
    var ele_type="";
  
    var cartUrl = domainUrl + "/cart/add?id[]=";
    var eleId = ele.id;
    var arr = eleId.split(":");

    
    var productNumberText = arr[0];
    var optionNumberText = arr[1];
  
    var type_start = productNumberText.indexOf("product");
    ele_type = productNumberText.substring(0,type_start);

    // Product and Option Number
    var pNo;
    var oNo;
  
    oNo = optionNumberText.replace('option_', '');
    if(ele_type=="all_"){
      ele_Integer = 1;
      productNumberText = productNumberText.replace('all_product_', '');
    }
    if(ele_type=="essen_"){
      ele_Integer = 0;
      productNumberText = productNumberText.replace('essen_product_', '');
    }
    if(ele_type=="upsell_"){
      ele_Integer = 2;
      productNumberText = productNumberText.replace('upsell_product_', '');
    }
    
    //Product ID
    var pId = parseInt(productNumberText);
    var element = document.getElementById(ele_type+"cart_tangent_product_"+pId+"_text");
    if(element!=undefined){
      element.classList.remove("added-to-cart-style");
    }

    // Product Details
    var pdt;
    for(var p=0;p<products.length;p++){
      if(products[p].id == pId){
        pdt = products[p];
      }
    }

    var variant_price = domainCurrency;

    // Product Variants
    var product_variants = pdt.variants;
    // Variant Option Values
    var opt1_value;
    var opt2_value;
    var opt3_value;

    // Getting current variant option selections
    if (product_variants.length > 0) {
        for (var pv = 0; pv < product_variants.length; pv++) {
            if (product_variants[pv].id == selected_pdt[pdt.id]) {
                prev_variant = product_variants[pv];
                opt1_value = product_variants[pv].option1;
                opt2_value = product_variants[pv].option2;
                opt3_value = product_variants[pv].option3;
            }
        }
    }

    var opt1_list;
    // Identify and Highlight new selection if it is on Option 1 list of Product
    if (ele.classList.contains("tangent_options_1")) {
        opt1_list = document.getElementsByClassName(ele_type+"product_" + pId + "v1");
        if (opt1_list.length > 0) {
            for (var op1 = 0; op1 < opt1_list.length; op1++) {
                if (op1 == oNo) {
                    opt1_list[op1].classList.add("tangent_selected-variant");
                    opt1_value = opt1_list[op1].innerHTML;
                }
                else {
                    opt1_list[op1].classList.remove("tangent_selected-variant");
                }
            }
        }
    }

    var opt2_list;
    // Identify and Highlight new selection if it is on Option 2 list of Product
    if (ele.classList.contains("tangent_options_2")) {
        opt2_list = document.getElementsByClassName(ele_type+"product_" + pId + "v2");
        if (opt2_list.length > 0) {
            for (var op2 = 0; op2 < opt2_list.length; op2++) {
                if (op2 == oNo) {
                    opt2_list[op2].classList.add("tangent_selected-variant");
                    opt2_value = opt2_list[op2].innerHTML;
                }
                else {
                    opt2_list[op2].classList.remove("tangent_selected-variant");
                }
            }
        }
    }

    var opt3_list;
    // Identify and Highlight new selection if it is on Option 3 list of Product
    if (ele.classList.contains("tangent_options_3")) {
        opt3_list = document.getElementsByClassName(ele_type+"product_" + pId + "v3");
        if (opt3_list.length > 0) {
            for (var op3 = 0; op3 < opt3_list.length; op3++) {
                if (op3 == oNo) {
                    opt3_list[op3].classList.add("tangent_selected-variant");
                    opt3_value = opt3_list[op3].innerHTML;
                }
                else {
                    opt3_list[op3].classList.remove("tangent_selected-variant");
                }
            }
        }
    }

    var option_variant_key;
    // Joining the options found and matching with options to variant mapping to get variant id
    if (opt1_value != null) {
        option_variant_key = opt1_value;
    }
    if (opt2_value != null) {
        option_variant_key = option_variant_key + "_" + opt2_value;
    }
    if (opt3_value != null) {
        option_variant_key = option_variant_key + "_" + opt3_value;
    }

    // Fetching and setting new variant id to selected product-id in product-variant map object
    if (option2_variant_map[pdt.id] != undefined) {
        if (option2_variant_map[pdt.id][option_variant_key] != undefined) {
            selected_pdt[pdt.id] = option2_variant_map[pdt.id][option_variant_key].id + "";
        }
    }

    var add_current_pdt = true;

    var cart_text_ele = document.getElementById(ele_type+"cart_tangent_product_" + pId + "_text");
    var cart_ele = document.getElementById(ele_type+"cart_tangent_product_" + pId);
    // Check if product is active and if not disable add to cart button
    if (pdt.status == "active") {
        if(cart_ele!=undefined){
          cart_ele.classList.remove("disable-btn-wrapper");
        }
        // Choose variant object from variant list in product object using variant id mapped to product id in product-variant mapping object
        var variant_select;
        if (product_variants.length > 0) {
            for (var pv = 0; pv < product_variants.length; pv++) {
                if (product_variants[pv].id == selected_pdt[pdt.id]) {
                    variant_select = product_variants[pv];
                }
            }
        }

        if (variant_select != undefined) {
            if(variant_select.inventory_policy == "deny"){
                if(variant_select.inventory_quantity<1){
                    if(variant_select.inventory_management!=null){
                        add_current_pdt = false;
                        if(cart_text_ele!=undefined){
                          cart_text_ele.innerHTML = outOfStock;
                        }
                      if(cart_ele!=undefined){
                        cart_ele.classList.add("disable-btn-wrapper");
                      }
                    }
                    else{
                        selected_pdt[pdt.id] = variant_select.id;
                        var pdt_cartUrl = cartUrl + selected_pdt[pdt.id];
                        if(cart_ele!=undefined){
                          cart_ele.classList.remove("disable-btn-wrapper");
                          var clickfun = cart_ele.getAttribute("onClick");
                          var funName = clickfun.substring(0,clickfun.indexOf("("));   
                          cart_ele.setAttribute("onclick",funName+"("+pId+","+ele_Integer+")");  
                        }
                      
                        if(cart_text_ele!=undefined){
                          cart_text_ele.innerHTML = default_addToCartText;
                        } 
                    } 
                }
                else{
                    selected_pdt[pdt.id] = variant_select.id;
                    var pdt_cartUrl = cartUrl + selected_pdt[pdt.id];
                    if(cart_ele!=undefined){
                      cart_ele.classList.remove("disable-btn-wrapper");
                      var clickfun = cart_ele.getAttribute("onClick");
                      var funName = clickfun.substring(0,clickfun.indexOf("("));   
                      cart_ele.setAttribute("onclick",funName+"("+pId+","+ele_Integer+")");   
                    }
                    if(cart_text_ele!=undefined){
                      cart_text_ele.innerHTML = default_addToCartText;
                    }
                    
                }
            }
            else{
                selected_pdt[pdt.id] = variant_select.id;
                var pdt_cartUrl = cartUrl + selected_pdt[pdt.id];
                if(cart_ele!=undefined){
                  cart_ele.classList.remove("disable-btn-wrapper");
                  var clickfun = cart_ele.getAttribute("onClick");
                  var funName = clickfun.substring(0,clickfun.indexOf("("));   
                  cart_ele.setAttribute("onclick",funName+"("+pId+","+ele_Integer+")");   
                }
                
                if(cart_text_ele!=undefined){
                  cart_text_ele.innerHTML = default_addToCartText;
                }
            }
        }
    }
    else {
        add_current_pdt = false;
        if(cart_text_ele!=undefined){
          cart_text_ele.innerHTML = outOfStock;
        }
        if(cart_ele!=undefined){
          cart_ele.classList.add("disable-btn-wrapper");
        }
    }

    var sp = 0;
    // Loop through product list and update cart url for add all to cart
    for (var p = 0; p < products.length; p++) {
        var product_variants = products[p].variants;

        // Check if product status , if not skip adding to cart-url
        if (products[p].status == "active") {
            // If looping product and selection product same
            if (products[p].id == pdt.id) {
                if (add_current_pdt) {
                    if (sp == 0) {
                        cartUrl = cartUrl + selected_pdt[pdt.id];
                    }
                    else {
                        cartUrl = cartUrl + '&id[]=' + selected_pdt[pdt.id];
                    }
                    sp = sp + 1;
                }
            }
            else {

                // Loop through variants of looping product and find matched variant from selected product-variant mapping object
                for (var pv = 0; pv < product_variants.length; pv++) {
                    if (selected_pdt[products[p].id] == product_variants[pv].id) {
                        var variant_select = product_variants[pv].id;
                        if(variant_select.inventory_policy == "deny"){
                            if(variant_select.inventory_quantity<1){
                            if(variant_select.inventory_management==null){
                                if (sp == 0) {
                                cartUrl = cartUrl + product_variants[pv].id;
                                }
                                else {
                                    cartUrl = cartUrl + '&id[]=' + product_variants[pv].id;
                                }
                                sp = sp + 1;
                            } 
                            }
                            else{
                                if (sp == 0) {
                                cartUrl = cartUrl + product_variants[pv].id;
                                }
                                else {
                                    cartUrl = cartUrl + '&id[]=' + product_variants[pv].id;
                                }
                                sp = sp + 1;
                            }
                        }
                        else{
                            if (sp == 0) {
                                cartUrl = cartUrl + product_variants[pv].id;
                            }
                            else {
                                cartUrl = cartUrl + '&id[]=' + product_variants[pv].id;
                            }
                            sp = sp + 1;
                        }
                    }
                }
            }
        }
        variant_product_url = domainUrl + '/products/';
        // To Set Variant Price dynamically 
        if (products[p].id == pdt.id) {
            var variant_pdt_matched = false;
            for (var pv = 0; pv < product_variants.length; pv++) {
                if (selected_pdt[products[p].id] == product_variants[pv].id) {
                    variant_pdt_matched = true;
                    variant_price = variant_price + product_variants[pv].price;
                    variant_product_url = variant_product_url + pdt.handle + "?variant=" + product_variants[pv].id;
                    
                    variant_image = getVariantImage(product_variants[pv].image_id, products[p]);
                }
            }
            if (!variant_pdt_matched) {
                variant_price = variant_price + product_variants[0].price;
                variant_product_url = variant_product_url + pdt.handle + "?variant=" + product_variants[0].id;
            }
            var cart_url = document.getElementById(ele_type+"url_tangent_product_" + pId)
            if(cart_url!=undefined){
              cart_url.href = variant_product_url;
            }
        }
    }
    var cart_price = document.getElementById(ele_type+"price_tangent_product_" + pId);
    if(cart_price!=undefined){
      cart_price.innerHTML = variant_price;
    }
      
    // Change of image based on variant
    if(variant_image!=undefined){
      var ele_img = document.getElementById(ele_type+"image_tangent_product_" + pId);
      if(ele_img!=undefined){
        ele_img.src = variant_image;
      }
    }

    addToCartCount = sp;
    addAllToCartLink = cartUrl;
}

const isSelectedVariantPresent = (selectedVariants, productId) => {
    for (let key in selectedVariants) {
        if (key == productId) {
            if (selectedVariants[key] == null) {
                return [];
            }
            else if (typeof selectedVariants[key] == "string") {
                return selectedVariants[key].split();
            }
            else {
                return selectedVariants[key];
            }
        }
    }
}

const getVariantImage = (imageId, product) => {
    var pdtImg;
    
    if(imageId!=null){
        var all_images = product.images;
        if(all_images!=undefined){
            for(var im=0;im<all_images.length;im++){
                if(imageId==all_images[im].id){
                    pdtImg = all_images[im].src;
                }
            }
        }
    }
    else{
        if(product.image!=null){
            pdtImg = product.image.src;
        }
        else{
            pdtImg = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
        }
    }

    if(pdtImg== undefined || pdtImg==null){
        pdtImg = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
    }
    return pdtImg;
}

function addToCart(id,status){ 
  var pdtid = Number(id);
  var pid = selected_pdt[pdtid];
  var section = "all_";
  if(status==0){
    section = "essen_"
  }
  else if(status==1){
    section = "basic_"
  }
  else if(status==2){
    section = "work_"
  }
  else{
    section = "all_";
  }
    var data = {
        "id": pid,
        "quantity": 1
    };
      
    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function() { 
            var elemID = section+"cart_tangent_product_"+id+"_text";
            var element = document.getElementById(elemID);
            if(element!=undefined){
              element.innerHTML = "Added to Cart!";
              element.classList.add("added-to-cart-style");
            }
            
            document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
            document.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
            })); 

            
        }, 
        error: function(XMLHttpRequest, textStatus, errorThrown) {
            console.log("Error on adding to cart",textStatus);
            Shopify.onError(XMLHttpRequest, textStatus);
        }
    });
    
}

function changeLoadingText(txt){
    // document.getElementById("loading_text").innerHTML = txt;
}
